var _polyline, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyArrowDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "9 14 4 9 9 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20v-7a4 4 0 0 0-4-4H4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyArrowDark);
export default __webpack_public_path__ + "static/media/reply-arrow-dark.2c2428474fb860536999bd016c2ee39c.svg";
export { ForwardRef as ReactComponent };